import { Component } from '@angular/core';

@Component({
  templateUrl: 'noaccess.component.html'
})
export class NoaccessComponent {

  constructor() { }

}
